import React from 'react';
export function validChildren(children) {
  return React.Children.toArray(children).filter(function (child) {
    return React.isValidElement(child) || typeof child === 'function';
  });
}